const S = ({ className = '' }: { className?: string }) => (
  <div className={`bg-gray-200 rounded animate-pulse ${className}`} />
);

const TimelineCardSkeleton = ({ isLast = false }: { isLast?: boolean }) => (
  <div className={`flex gap-3 sm:gap-5 ${isLast ? '' : 'pb-8'}`}>
    {/* Milestone dot */}
    <div className="relative z-[1] flex flex-shrink-0 flex-col items-center">
      <div className="h-7 w-7 rounded-full border-2 border-gray-200 bg-white" />
    </div>

    {/* Provider card */}
    <div className="min-w-0 flex-1 rounded-xl border border-gray-100 bg-gray-50/50 p-4 sm:p-6">
      <div className="flex flex-col gap-4 sm:flex-row sm:gap-6">

        {/* LEFT: icon -> name -> tag */}
        <div className="flex-shrink-0 sm:w-[180px]">
          <S className="mb-3 h-11 w-11 rounded-xl" />
          <S className="mb-2 h-4 w-32" />
          <S className="h-4 w-24 rounded-full" />
        </div>

        {/* RIGHT: What They Do + Why You Need Them */}
        <div className="flex min-w-0 flex-1 flex-col gap-3">
          <div className="rounded-lg border border-gray-100 bg-white px-4 py-3">
            <S className="mb-1.5 h-3 w-28" />
            <S className="h-3.5 w-full mb-1.5" />
            <S className="h-3.5 w-[90%]" />
          </div>
          <div className="rounded-lg border-l-4 border-gray-200 bg-gray-100/60 px-4 py-3">
            <S className="mb-1.5 h-3 w-32" />
            <S className="h-3.5 w-full mb-1.5" />
            <S className="h-3.5 w-[80%]" />
          </div>
        </div>
      </div>
    </div>
  </div>
);

export const ProviderOverviewSkeleton = () => {
  return (
    <div className="relative flex flex-col animate-pulse">
      {/* Continuous timeline track */}
      <div
        className="absolute left-[0.875rem] top-[0.875rem] bottom-[0.875rem] w-0.5 rounded-full bg-gray-200"
        aria-hidden="true"
      />

      <TimelineCardSkeleton />
      <TimelineCardSkeleton />
      <TimelineCardSkeleton isLast />
    </div>
  );
};
